// extracted by mini-css-extract-plugin
export default {"iconPremium":"IconPremiumSilver_iconPremium__NWsLu"};